import styles from "./teamvcard.module.scss";
import { MdPhone, MdEmail, MdLanguage, MdPermContactCalendar } from "react-icons/md";
import { FaLinkedin } from "react-icons/fa";
import IconLink from "./IconLink";
import { Link, useLocation } from "react-router-dom";
import { ContactData, useGetOneContact } from "../../queries/contact";
import { useEffect, useState } from "react";

const TeamVCard = () => {
  const { pathname } = useLocation();
  const [contact, setContact] = useState<ContactData | null>(null);
  const param = pathname.split("/")[2];
  const { data } = useGetOneContact(param);

  useEffect(() => {
    if (data) {
      setContact(data.oneContact);
    }
  }, [data]);

  const icons = (title: string) => {
    switch (title) {
      case "Phone":
        return <MdPhone size={32} color="white" />;
      case "Email":
        return <MdEmail size={32} color="white" />;
      case "LinkedIn":
        return <FaLinkedin size={32} color="white" />;
      case "Url":
        return <MdLanguage size={32} color="white" />;
      default:
        return <MdPhone size={32} color="white" />;
    }
  };

  return (
    <div className={`${styles.cardContainer} ${styles.animated}`}>
      {contact && (
        <>
          <div className={styles.cardInner}>
            <div className={styles.contactData}>
              <div className={styles.imageContainer}>
                <img src={contact.photo} alt="avatar" />
              </div>
              <div>
                <h2 className={styles.contactName}>{contact.name}</h2>
                <p className={styles.contactTitle}>{contact.title}</p>
              </div>
              <div className={styles.logoContainer}>
                @
                <img
                  src="/media/images/BioLean_Logo_Transparent.png"
                  alt="avatar"
                />
              </div>
              <div className={styles.linksContainer}>
                {contact.contactLinks.map((item) => (
                  <IconLink
                    key={item.title}
                    icon={icons(item.title)}
                    href={item.href}
                    title={item.title}
                  />
                ))}
              </div>
            </div>
            <div className={styles.companyData}>
              <p className={styles.companyDescription}>
                At BioLean we boost the digital transformation of our partners
                by providing AI based solutions that optimize the utilization of
                production assets and help employees thrive.
              </p>
              <div className={styles.companyContact}>
                <div className={styles.url}>
                  <a
                    href="https://www.biolean.dk"
                    target="_blank"
                    rel="noreferrer"
                    className={styles.urlLink}
                  >
                    <IconLink icon={icons("Url")} />
                    <p>www.biolean.dk</p>
                  </a>
                </div>
                <div className={styles.location}>
                  <h4>BioLean ApS</h4>
                  <p>Algade 2D</p>
                  <p>4281 Gørlev</p>
                  <p>Denmark</p>
                </div>
              </div>
            </div>
            <div className={styles.buttonContainer}>
              <Link
                to={contact.vcard}
                target="_blank"
                download
              >
                <MdPermContactCalendar color="white" size={20} />
                Download vCard
              </Link>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default TeamVCard;
